import { Component, OnInit } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { SettingService } from '../../_services/setting.service';
@Component({
  selector: 'app-ink-type',
  templateUrl: './ink-type.component.html',
  styleUrls: ['./ink-type.component.css']
})
export class InkTypeComponent implements OnInit {
  public totalProjectQuantity: any = [];
  public grandTotalPrice = 0;
  public activeProjectIndex = "";
  public projects: any = {};
  public loading = false;
  public Options: any = {};
  public inkTypeLists: Array<any> = [];
  public selected = 0;
  public storeInkidValue: string;
  public storeInknameValue: string;
  public tempProjectData: any = {};
  public orderType: string;
  public prevPrice = 0;
  public isPublicQuoteCreation = false;

  constructor(private CommonProjectDataService: CommonProjectDataService,
    private CommonService: CommonService,
    private router: Router,
    private settingService: SettingService
  ) {
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.isAccessInvoiceType();
  }

  ngOnInit() {
    this.orderType = this.CommonProjectDataService.getOrderType();
    this.totalProjectQuantity = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalProjectQuantity()));
    this.grandTotalPrice = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalPrice()));
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.selected = this.CommonProjectDataService.getInkIndex();
    this.getInkType();
    this.prevPrice=JSON.parse(localStorage.getItem('prevPrice'));
    this.showConfirmMessage();    
    this.CommonProjectDataService.storeCurrentIndexForStep(4);
  }

  getInkType = function () {
    this.loading = true;
    this.Options = {
      id: localStorage.getItem("userID")
    };

    this.CommonService.apiService(
      "POST",
      "ink_types",
      this.Options
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.inkTypeLists = response.data.records;
            let selectedInkTypeId = this.inkTypeLists[0]['ink_type_id'];
            let selectedInkTypeName = this.inkTypeLists[0]['name'];
            if (this.projects.projects_data[this.activeProjectIndex]['ink_Details'] && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].name) {
              selectedInkTypeId = this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id;
              selectedInkTypeName = this.projects.projects_data[this.activeProjectIndex]['ink_Details'].name;
              this.selected = this.inkTypeLists.findIndex(item => item.ink_type_id == this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id);
            }
            this.setActiveVariable(this.selected, selectedInkTypeId, selectedInkTypeName);
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  setActiveVariable(index, InkID, InkName) {
    this.selected = index
    this.CommonProjectDataService.storeInkId(InkID);
    this.CommonProjectDataService.storeInkName(InkName);
    this.CommonProjectDataService.storeInkIndex(this.selected);
    this.storeInkidValue = this.CommonProjectDataService.getInkId();
    this.storeInknameValue = this.CommonProjectDataService.getInkName();
    this.processInkTypeData();
    this.CommonProjectDataService.store(this.projects);
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice(this.tempProjectData);
  }

  processInkTypeData() {
    if (!this.storeInkidValue) // if a is negative,undefined,null,empty value then...
    {
      if (this.inkTypeLists[0] && this.inkTypeLists[0]['ink_type_id']) {
        this.projects.projects_data[this.activeProjectIndex]['ink_Details'] = {
          'ink_type_id': this.inkTypeLists[0]['ink_type_id'],
          'ink_name': this.inkTypeLists[0]['name']
        };
      }
    }
    else {
      this.projects.projects_data[this.activeProjectIndex]['ink_Details'] = {
        'ink_type_id': this.storeInkidValue,
        'ink_name': this.storeInknameValue
      };
    }
  }

  getPrice = function (datarecord) {
    this.loading = true;
    let projects = datarecord;
    let user_id = this.projects.user_id;
    let finalArr = []

    projects.forEach((pvalue, pkey) => {
      let activeLoc = pvalue.active_location_arr;
      let projectTitle = (pvalue.projectTitle) ? pvalue.projectTitle : "";
      if (sessionStorage.getItem(`projectTitle_${pkey}`)) {
        projectTitle = sessionStorage.getItem(`projectTitle_${pkey}`);
      }
      let isCheckedProjectTab = (pvalue.isCheckedProjectTab) ? pvalue.isCheckedProjectTab : "";
      let totalPriceCalculation = (pvalue.totalPriceCalculation) ? pvalue.totalPriceCalculation : false;
      if (pvalue.products && pvalue.products.length > 0) {
        pvalue.products.forEach((product, key) => {
          if (finalArr[pkey] && finalArr[pkey].products) {
            Object.assign(finalArr[pkey].products, { [product.product_id]: {} });
            Object.assign(finalArr[pkey].products_matrix, { [product.product_id]: {} });
          }
          else {
            finalArr[pkey] = {
              'products': { [product.product_id]: {} },
              'products_matrix': { [product.product_id]: {} },
              'printPositionSetting': pvalue.printPositionSetting,
              'finishingDetails': (pvalue.finishing_type_id) ? pvalue.finishing_type_id : [],
              'inkDetail': (pvalue.ink_Details && pvalue.ink_Details.ink_type_id) ? pvalue.ink_Details.ink_type_id : null,
              'section_items': pvalue.section_items,
              'isCheckedProjectTab': isCheckedProjectTab,
              'projectTitle': projectTitle,
              'productsMatrixData': pvalue.products,
              'totalPriceCalculation': totalPriceCalculation
            };
          }
          finalArr[pkey].ownGarmentsWeight = pvalue.ownGarmentsWeight;
          // set inkColors under printPositionSetting
          if (activeLoc && activeLoc.length > 0) {
            activeLoc.forEach((lval, lkey) => {
              if (pvalue.inkColors && pvalue.inkColors[lval.emblocation_id]) {
                let tmpInkColor = (pvalue.inkColors[lval.emblocation_id]) ? pvalue.inkColors[lval.emblocation_id] : [];
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['inkColors'] = tmpInkColor;
                }
                else {
                  pvalue.printPositionSetting[lval.emblocation_id] = { ['inkColors']: tmpInkColor };
                }
              }
              // set printAddonSetting under printPositionSetting
              if (pvalue.printAddonSetting) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['printAddonSetting'] = (pvalue.printAddonSetting[lval.emblocation_id]) ? pvalue.printAddonSetting[lval.emblocation_id] : {};
                }
              }

              // set inkChangeData under printPositionSetting
              if (pvalue.inkChangeData) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {

                  if (pvalue.inkChangeData[lval.emblocation_id]) {

                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = this.processInkChangeData(pvalue.inkChangeData[lval.emblocation_id]);

                  }
                  else {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = [];
                  }

                }
              }
              if (pvalue.artwork) {
                let artTmp = Object.keys(pvalue.artwork).length;
                if (pvalue.artwork && artTmp > 0) {
                }
              }
              finalArr[pkey].printPositionSetting = pvalue.printPositionSetting;
              product.matrix.forEach(function (mval, mkey) {
                if (finalArr[pkey].products[product.product_id]) {
                  Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                  Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
                }
                else {
                  finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                  finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
                }
                mval.quantity.forEach(function (qval, qkey) {
                  if (qval && qval > 0) {
                    if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                      Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                    }
                    else {
                      finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                    }
                  }
                });
              });
            });
          }
          else {
            product.matrix.forEach(function (mval, mkey) {
              if (finalArr[pkey].products[product.product_id]) {
                Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
              }
              else {
                finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
              }
              mval.quantity.forEach(function (qval, qkey) {
                if (qval && qval > 0) {
                  if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                    Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                  }
                  else {
                    finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                  }
                }
              });
            });
          }
        });
      }

    });
    this.address_id = (this.projects.shipping_address && this.projects.shipping_address.address_id) ? this.projects.shipping_address.address_id : this.projects.address_id ? this.projects.address_id : '';

    let otherData = {
      user_id: this.projects.user_id ? this.projects.user_id : '',
      address_id: this.address_id,
      turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
      shipping_method: this.projects.shipping_method_key == "null" ? "" : this.projects.shipping_method_key
    }
    let quoteOpt = {
      id: localStorage.getItem("userID"),
      projects_data: finalArr,
      user_id: otherData.user_id,
      address_id: otherData.address_id,
      turn_around_time: otherData.turn_around_time,
      shipping_method: otherData.shipping_method,
      one_time_discount_type: this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
      one_time_discount: this.projects.one_time_discount ? this.projects.one_time_discount : 0,
      is_tax_exempt: this.CommonProjectDataService.getIsTaxExempt(),
      tax_rate: this.CommonProjectDataService.getTaxRate(),
    };
    this.CommonService.apiService(
      "POST",
      "v3/order/get_prices",
      quoteOpt
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.grandTotalPrice = response.data.grand_total_price;
          this.CommonProjectDataService.storeTotalPrice(response.data.grand_total_price);
          if(this.orderType == 'Quote'){
            this.projects.delivery_date = response.data.delivery_date;
          }
          this.projects.delivery_days = response.data.delivery_days;
          this.projects.discount = response.data.discount;
          this.projects.discount_percentage = response.data.discount_percentage;
          this.projects.grand_total_price = response.data.grand_total_price;
          this.projects.shipping_price = response.data.shipping_price;
          this.projects.tax = response.data.tax;
          this.projects.tax_percentage = response.data.tax_percentage;
          this.projects.total_price = response.data.total_price;
          this.projects.total_printing_price = response.data.total_printing_price;
          this.projects.total_products_price = response.data.total_products_price;
          this.projects.total_quantity = response.data.total_quantity;
          this.projects.total_weight = response.data.total_weight;
          this.projects.turn_around_time_price = response.data.turn_around_time_price;
          this.projects.total_projects = response.data.total_projects;
          this.projects.total_custom_items_price = response.data.total_custom_items_price;
          this.projects.turn_around_time = '0';
          this.projects.one_time_discount = response.data.one_time_discount;
          this.projects.one_time_discount_type = response.data.one_time_discount_type;
          this.projects.one_time_discounted_amt = response.data.one_time_discounted_amt;

          // set  printing price  per project
          this.projects.projects_data[this.activeProjectIndex].total_printing_price = response.data.projects[this.activeProjectIndex].total_printing_price;

          this.projects.projects_data[this.activeProjectIndex].priceMarkupProduct = response.data.projects[this.activeProjectIndex].priceMarkupProduct;
          response.data.projects.forEach((projectValues, projectIndexing) => {
            this.projects.projects_data[projectIndexing].perProjectTotalCost = projectValues.perProjectTotalCost;
            this.projects.projects_data[projectIndexing].products = projectValues.productsMatrixData;
            this.projects.projects_data[projectIndexing].priceDistributionData = projectValues.perProductPriceDistributionData;
            this.projects.projects_data[projectIndexing].projectTitle = projectValues.projectTitle;
          });

          if (otherData.shipping_method == "" || otherData.shipping_method == "local_pickup") {
            this.projects.shipping_method = response.data.shipping_methods.local_pickup;
          }

          this.loading = false;
          this.showConfirmMessage();
        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );
  }

  processInkChangeData(inkData) {
    let tmpArr = [];
    inkData.updData.forEach((val, key) => {
      tmpArr[key] = { 'inkColors': [] };
    });

    Object.values(inkData.colorChange).forEach((val, key) => {
      Object.entries(val).forEach(
        ([pkey, value]) => {
          if (tmpArr[key].inkColors) {
            tmpArr[key].inkColors.push(val[pkey].upd.ink_id);
          }
          else {
            tmpArr[key] = { inkColors: [val[pkey].upd.ink_id] };
          }
        }
      );

    });
    return tmpArr;
  }

  showConfirmMessage() {
    if (this.grandTotalPrice > 0 && this.prevPrice != this.grandTotalPrice) {
      localStorage.setItem("isorder", 'yes');
    }
  }

  isAccessInvoiceType() {
    const hasOrderType = this.CommonProjectDataService.getOrderType();
    const isInvoiceEditable = this.CommonProjectDataService.getIsInvoiceEditable();
    const isRedirectUrl = this.settingService.isAccessInvoiceType(hasOrderType, this.isPublicQuoteCreation, isInvoiceEditable);
    if (isRedirectUrl) {
      return this.router.navigate([isRedirectUrl]);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/ink-type/ink-type.component.ts